import { useCallback, useEffect } from 'react';
import useFrozenState from './use-frozen-state';

const useObjectState = (initialValues = {}, inputs = []) => {
  const [state, _setState] = useFrozenState(initialValues);

  const setState = useCallback(
    next =>
      _setState((prevState, ...args) => {
        const nextState = typeof next === 'function' ? next(prevState, ...args) : next;
        return prevState !== nextState && typeof prevState === 'object' && typeof nextState === 'object'
          ? {
              ...prevState,
              ...nextState,
            }
          : nextState;
      }),
    [_setState],
  );

  const initialValuesToState = useCallback(() => {
    setState(initialValues);
  }, [initialValues, setState]);

  useEffect(initialValuesToState, inputs);

  return [state, setState];
};

export default useObjectState;
